export const enum ArgumentsEnum {
  'RESTAURANT-INFO-SECTION-ADDRESS' = 'restaurant-info-section-address',
  'RESTAURANT-INFO-SECTION-RESTAURANTNAME' = 'restaurant-info-section-restaurantName',
  'RESTAURANT-INFO-SECTION-PHONENUMBER' = 'restaurant-info-section-phoneNumber'
}